import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import { resolveAuthNavigation } from './guards';

const LoginForm = () => import('../components/LoginForm.vue');
const RegisterForm = () => import('../components/RegisterForm.vue');
const Home = () => import('../views/HomeApp.vue');
const PortalView = () => import('../views/PortalView.vue');
const MyObjectsView = () => import('../views/MyObjectsView.vue');
const VideoStream = () => import('../views/VideoStream.vue');
const ReportsView = () => import('../views/ReportsView.vue');
const ContactForm = () => import('../views/ContactForm.vue');
const NoAccess = () => import('../views/NoAccess.vue');
const AdminDashboard = () => import('../views/AdminDashboard.vue');
const DroneDetail = () => import('../views/DroneDetail.vue');

const routes = [
  { path: '/login', name: 'Login', component: LoginForm },
  { path: '/register', name: 'Register', component: RegisterForm },
  { path: '/home', name: 'Home', component: Home, meta: { requiresAuth: true } },
  { path: '/portal', alias: ['/my-streams'], name: 'PortalView', component: PortalView, meta: { requiresAuth: true } },
  { path: '/my-objects', name: 'MyObjectsView', component: MyObjectsView, meta: { requiresAuth: true } },
  { path: '/streams', alias: ['/videostream'], name: 'VideoStream', component: VideoStream, meta: { requiresAuth: true } },
  { path: '/streams/:key', name: 'StreamViewer', component: VideoStream, meta: { requiresAuth: true } },
  { path: '/videostream2', redirect: '/streams' },
  { path: '/drones/:id', name: 'DroneDetail', component: DroneDetail, meta: { requiresAuth: true } },
  { path: '/reports', name: 'ReportsView', component: ReportsView, meta: { requiresAuth: true } },
  { path: '/contactform', name: 'ContactForm', component: ContactForm, meta: { requiresAuth: true } },
  { path: '/settingsvideo', redirect: '/streams' },
  { path: '/no-access', name: 'NoAccess', component: NoAccess },
  { path: '/admin', name: 'AdminDashboard', component: AdminDashboard, meta: { requiresAuth: true, requiresRole: 'admin' } },
  { path: '/', redirect: '/home' }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const userRole = store.getters['auth/userRole'];
  next(resolveAuthNavigation(to, isAuthenticated, userRole));
});

export default router;
